import React, { useState } from "react";
import { service } from "../services/service";
import logo from "../imgs/Logo CodeSour.png";
import { Button, Card, Col, Row, Form, Input } from "antd";

function Login() {
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [statusEmail, setStatusEmail] = useState();
  const [timer, setTimer] = useState();

  function isValidEmail(email) {
    // Define a regular expression pattern for email validation.
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  function onRegister() {
    if (
      name !== "" &&
      surname !== "" &&
      email !== "" &&
      password !== "" &&
      confirmPassword !== ""
    ) {
      service.createUser(name, surname, email, password);
    }
  }

  function onSetTaskName(event) {
    clearTimeout(timer);
    setTimer(
      setTimeout(() => {
        if (isValidEmail(email)) {
          setEmail(email);
          setStatusEmail();
        } else {
          setStatusEmail("error");
        }
      }, 1000)
    );
  }

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <>
      <Row>
        <Col span={24} sm={{ span: 11, offset: 7 }}>
          <img src={logo} alt="Logo" />
        </Col>
      </Row>
      <Row>
        <Col span={24} sm={{ span: 12, offset: 6 }}>
          <Card style={{ paddingTop: "2em", paddingBottom: "2em" }}>
            <Form
              name="basic"
              layout="vertical"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="on"
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true }]}
                  >
                    <Input
                      placeholder="Insert Name"
                      onChange={(event) => {
                        setName(event.target.value);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Surname"
                    name="surname"
                    rules={[{ required: true }]}
                  >
                    <Input
                      placeholder="Insert Surname"
                      onChange={(event) => {
                        setSurname(event.target.value);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label="E-mail"
                    name="email"
                    rules={[{ required: true }]}
                  >
                    <Input
                      placeholder="Insert E-mail"
                      onChange={onSetTaskName}
                      status={statusEmail}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Insert Password"
                      onChange={(event) => {
                        setPassword(event.target.value);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Confirm Password"
                    name="Confirm Password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Insert Confirm Password"
                      onChange={(event) => {
                        setConfirmPassword(event.target.value);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={"end"} gutter={16}>
                <Col>
                  <Button type="link" href="/login">
                    Log In
                  </Button>
                </Col>
                <Col>
                  <Button type="primary" onClick={onRegister} htmlType="submit">
                    Sign In
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default Login;
